/**
 *
 * UserProvider
 *
 */

import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';

import { sessionToken } from 'utils';

import BootGate from '../BootProvider/BootGate';
// Components
import reducer from './ducks';
import saga from './saga';
import useUser from './useUser';

export function UserProvider(props) {
  useInjectReducer({ key: 'userProvider', reducer });
  useInjectSaga({ key: 'userProvider', saga });

  const { children } = props;

  // Hooks
  const history = useHistory();
  const { pathname, search } = useLocation();

  // Custom hooks
  const { isAuthenticated, refresh, twoFactorRequired } = useUser();
  const { token } = sessionToken();

  // States
  const [sessionVerified, setSessionVerified] = useState(false);

  const callback = useCallback(
    (onSuccess, onError) => {
      if (onError) history.push(`/login?redirect=${pathname}`);

      setTimeout(() => setSessionVerified(true), 250);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history],
  );

  useEffect(() => {
    if (!sessionVerified) {
      if (isAuthenticated) {
        refresh({ callback });
      } else {
        setSessionVerified(true);
      }
    }
  }, [isAuthenticated, sessionVerified, refresh, callback]);

  useEffect(() => {
    if (isAuthenticated && !token) {
      refresh({ callback });
    }
  }, [isAuthenticated, token, refresh, callback]);

  useEffect(() => {
    if (twoFactorRequired && pathname !== '/login') {
      const currentRedirect = new URLSearchParams(search).get('redirect');
      if (currentRedirect) {
        history.push(`/login${search}`);
      } else {
        const target = encodeURIComponent(`${pathname}${search}`);
        history.push(`/login?redirect=${target}`);
      }
    }
  }, [twoFactorRequired, pathname, search, history]);

  if (sessionVerified) return children;

  return <BootGate />;
}

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UserProvider;
export { useUser };
